import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

function RoleProtectedRoute({ children, allowedRoles = [], fallbackPath = "/assessments" }) {
  const location = useLocation();
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Show access denied message or redirect to fallback
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <p>Required role: {allowedRoles.join(' or ')}</p>
        <p>Your role: {user.role}</p>
        <Navigate to={fallbackPath} replace />
      </div>
    );
  }

  return children;
}

export default RoleProtectedRoute;